// /src/pages/private/setting/Settings.jsx

import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SidebarMenu from '../../../components/private/SideBarMenu';
import Account from './Account';
import Security from './Security';

import Tools from './Tools';

export default function UserSettings() {
    const { t } = useTranslation();

    return (
        <div className="user-settings-page">
            
            <div className="settings-container">
                <div className="user-settings-sidebar">
                    <SidebarMenu />
                </div>
                <div className="user-settings-content-wrapper glass-card2">
                    <div className="user-settings-content">
                        <Routes>
                            <Route path="account" element={<Account />} />
                            <Route path="security" element={<Security />} />
                            <Route path="tools" element={<Tools />} />
                        </Routes>
                    </div>
                </div>
            </div>
        </div>
    );
}
